import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { fetchAssetPreviewImage } from '../lib/api/assets'
import { selectors } from '../reducers/appReducer';
import noPhotoImg from '../images/no-photo.png';

/**
 * Questo hook è per immagini singole, si aspetta come input un url di una immagine e non un array di immagini
 *
 * @param assetSrc
 * @returns {{previewImage: unknown, loading: boolean, error: unknown}}
 */
export const useAssetPreview = (assetSrc) => {
    const [previewImage, setPreviewImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const imagePlaceholder = useSelector(selectors.getDefaultPlaceholderImage)?.imageUrl
    const imagePlaceholderUrl = imagePlaceholder === './images/no-photo.png' ? noPhotoImg : imagePlaceholder

    const previewFileExtensionList = useSelector(selectors.getPreviewFileExtensionList) || []

    const checkFileExtension = (filename, extensionsList) => {
        const lowerName = filename.toLowerCase()

        // Se non ho estensione assumo che sia una immagine trasmessa direttamente dall'endpoint, che sia il suo base64
        if (!lowerName.includes('.') && lowerName.includes('?')) {
            console.log('si è correttamente riconosciuta il base64')
            return true;
        }
        return extensionsList.some(extension => lowerName.endsWith(extension));
    }

    // Nuova funzione per controllare se è un'immagine diretta (jpg, png)
    const isDirectImageFile = (filename) => {
        const lowerName = filename.toLowerCase();
        return lowerName.endsWith('.jpg') ||
            lowerName.endsWith('.jpeg') ||
            lowerName.endsWith('.png');
    }

    useEffect(() => {
        const fetchPreview = async () => {
            try {
                setLoading(true);
                setError(null);

                if (!assetSrc) {
                    setPreviewImage(imagePlaceholderUrl);
                    return;
                }

                if (!checkFileExtension(assetSrc, previewFileExtensionList)) {
                    // Se non passa il check delle estensioni supportate per l'anteprima,
                    // ma è un'immagine diretta (jpg/png), usa l'src originale
                    if (isDirectImageFile(assetSrc)) {
                        setPreviewImage(assetSrc);
                    } else {
                        setPreviewImage(imagePlaceholderUrl);
                    }
                    return;
                }

                const params = { name: assetSrc };
                const result = await fetchAssetPreviewImage(params);

                if (!result) {
                    console.log('no result for params => ', params)
                    setPreviewImage(imagePlaceholderUrl);
                } else {
                    setPreviewImage(result);
                }
            } catch (err) {
                setError(err);
                setPreviewImage(imagePlaceholderUrl);
            } finally {
                setLoading(false);
            }
        };

        fetchPreview();
    }, [assetSrc, imagePlaceholder, previewFileExtensionList]);

    return { previewImage, loading, error };
};